export default class Dropdowns {
  constructor(options) {
    this.$el = options.$el;

    this.raf = null;
    this.labels = [].slice.call(
      this.$el.querySelectorAll(".js-dropdowns-label")
    );

    // Listen global resize
    this._toggle = this.toggle.bind(this);

    this.setEvents();
  }

  setEvents() {
    this.labels.forEach((element) => {
      element.addEventListener("click", this._toggle);
    });
  }

  removeEvents() {
    this.labels.forEach((element) => {
      element.removeEventListener("click", this.toggle.bind(this));
    });

    if (!!this.raf) cancelAnimationFrame(this.raf);
  }

  toggle(e) {
    const target = e.currentTarget;
    const section = target.nextElementSibling;

    if (section.getAttribute("data-collapsed") === "true") {
      this.expandSection(section, true);
    } else {
      this.collapseSection(section);
    }
  }

  expandSection(element, closeAllSection = false) {
    if (closeAllSection) {
      const alreadyOpen = this.$el.querySelectorAll('[data-collapsed="false"]');

      if (
        !!alreadyOpen &&
        !!alreadyOpen.length > 0 &&
        alreadyOpen !== element
      ) {
        alreadyOpen.forEach((item) => {
          this.collapseSection(item);
        });
      }
    }

    const sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + "px";
    element.classList.add("is-open");
    element.parentNode.classList.add("is-open");
    element.previousElementSibling.classList.add("is-open");
    element.setAttribute("data-collapsed", "false");
  }

  collapseSection(element) {
    element.style.transition = "";
    this.raf = requestAnimationFrame(() => {
      element.style.height = element.scrollHeight + "px";
      this.raf = requestAnimationFrame(() => {
        element.style.height = 0 + "px";
      });
    });

    element.classList.remove("is-open");
    element.parentNode.classList.remove("is-open");
    element.previousElementSibling.classList.remove("is-open");
    element.setAttribute("data-collapsed", "true");
  }

  destroy() {
    this.removeEvents();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Dropdowns.js